export const config = {
  roles: import.meta.env.VITE_ROLES.split(","),
  platforms: import.meta.env.VITE_PLATFORMS.split(","),
  secretStore: JSON.parse(import.meta.env.VITE_ACCOUNTS_OBJECT || "{}"),
  projects: JSON.parse(import.meta.env.VITE_APP_PROJECTS || "[]"),
  environments: JSON.parse(import.meta.env.VITE_ENVIRONMENTS || "[]"),
  secretTypes: JSON.parse(import.meta.env.VITE_SECRET_TYPE || "[]"),
  apiAccess: import.meta.env.VITE_API_ACCESS,
};